﻿

	 import { SearchFilter } from '@models/search-filters/SearchFilter';
    
    /**
    * 
    */
    
    export class CollectionSearchFilter extends SearchFilter {
        
        
        id?: number | null;
    }
